import { Row } from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import { Button, Input, Space, Table, Form, InputNumber, Empty } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
// import RefreshIcon from '@mui/icons-material/Refresh';
import Highlighter from 'react-highlight-words';
import { useSelector, useDispatch } from 'react-redux'
import {
    setFile, getStyle, getObjective, getServices
} from '../../../../libs/todoSlice'
//function edit table
const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
// end edit table
const AddOfficerSuccess = ({ memberOneSuccess, memberCASuccess }) => {
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const objective = useSelector(getObjective)
    const services = useSelector(getServices)
    // function show member to success table
    useEffect(() => {
        

        setData(memberOneSuccess.map((members) => {
            const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
            const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
            const title_en = title_en_list[title_th_list.indexOf(members.request.title_th)]
            return {
                index: members.request.index,
                contract_no: members.request.contract_no,
                employee_id: members.request.employee_id,
                title_th: members.request.title_th,
                title_en: title_en,
                title_special_th: members.request.title_special_th,
                special_title_th: members.request.special_title_th,
                special_title_eng: members.request.special_title_eng,
                birth_date: members.request.birth_date,
                name_th: members.request.name_th,
                surname_th: members.request.surname_th,
                name_eng: members.request.name_eng,
                surname_eng: members.request.surname_eng,
                id_card_type: members.request.id_card_type,
                middle_name_th: members.request.middle_name_th,
                middle_name_eng: members.request.middle_name_eng,
                cid: members.request.cid,
                tel: members.request.tel,
                mobile: members.request.mobile,
                email: members.request.email,
            }
        }))
    }, [memberOneSuccess])
    // end function show member to success table
    //function edit table
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.index === editingKey;

    const cancel = () => {
        setEditingKey('');
    };


    // function search
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };


    const mergedColumns = [
        {
            title: 'ลำดับที่',
            dataIndex: 'index',
            width: 100,
            show: true,
            editable: true,
            fixed: 'left',
            render: (__, _, index) => parseInt(index) + 1,
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาไทย)</>),
            dataIndex: 'title_th',
            width: 150,
            // width: '10%',
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('title_th'),
        },
        {
            title: (<>คำนำหน้า <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'title_en',
            width: 150,
            // width: '10%',
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('title_th'),
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาไทย)</>),
            dataIndex: 'special_title_th',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>คำนำหน้าอื่นๆ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'special_title_eng',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาไทย)</>),
            dataIndex: 'name_th',
            width: 150,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>ชื่อกลาง <br />(ภาษาไทย)</>),
            dataIndex: 'middle_name_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาไทย)</>),
            dataIndex: 'surname_th',
            width: 150,
            // width: '10%',
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_th'),
        },
        {
            title: (<>ชื่อ <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'name_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_eng'),
        },
        {
            title: (<>ชื่อกลาง <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'middle_name_eng',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<>นามสกุล <br />(ภาษาอังกฤษ)</>),
            dataIndex: 'surname_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('surname_eng'),
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'id_card_type',
            width: 150,
            show: true,
            editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            width: 150,
            show: true,
            editable: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },
        {
            title: 'โทรศัพท์',
            dataIndex: 'tel',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('tel'),
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            width: 250,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('email'),
        },
        {
            title: 'วันเกิด',
            dataIndex: 'birth_date',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('cid'),
        },

    ].filter(head => !head.hidden && head.show).map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ||
                    col.dataIndex === 'index' ||
                    col.dataIndex === 'no' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // end edit table
    return (
        <>
            {/* <Row style={{marginBottom:'20px'}}>
            <Col className="d-flex justify-content-end">
              <Button size="large" > <RefreshIcon/> Resend Mail </Button>
            </Col>
          </Row> */}
            <Row>
                {/* ui table */}
                <Form form={form} component={false}>
                    <Table
                        locale={customLocale}
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        bordered
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={{
                            onChange: cancel,
                        }}
                        scroll={{
                            x: 1400,
                            y: 400,
                        }}

                    />
                </Form>
                {/* end ui table */}
            </Row>
        </>
    )

}
export default AddOfficerSuccess